module.exports = __webpack_public_path__ + "static/media/search.a92f8c46.svg";